import { extendTheme } from '@chakra-ui/react';
import { CardComponent } from './additions/card/card';
import { badgeStyles } from './components/badge';
import { inputStyles } from './components/input';
import { progressStyles } from './components/progress';
import { sliderStyles } from './components/slider';
import { textareaStyles } from './components/textarea';
import { switchStyles } from './components/switch';
import { linkStyles } from './components/link';
import { globalStyles } from './styles';

/**
 * ORDER IS LOAD-BEARING. `extendTheme` only treats its LAST argument as the
 * base when that argument is itself a complete Chakra theme; ours is
 * `CardComponent`, which is not — so every argument merges left-to-right over
 * Chakra's defaults, later wins.
 *
 * `globalStyles` is itself the output of `extendTheme(...)` in styles.js, i.e.
 * a COMPLETE theme carrying every Chakra default. It used to sit second-to-last,
 * which silently replayed those defaults over everything before it: the custom
 * breakpoints reverted to Chakra's, and badgeStyles' radius/variants were
 * clobbered. It must stay FIRST so the small override objects after it win.
 */
export default extendTheme(
	globalStyles,

	/**
	 * Breakpoints are PINNED to the values the app has actually been running
	 * with (Chakra defaults + the two custom keys Chakra doesn't define).
	 * The old `foundations/breakpoints.js` scale (320/768/960/1200px) was
	 * silently dead under the previous merge order; restoring it now would
	 * shift every responsive prop in the app, which is out of scope for the
	 * theme work. Revisit deliberately if the custom scale is ever wanted.
	 */
	{
		breakpoints: {
			'2sm': '380px',
			sm: '30em',
			md: '48em',
			lg: '62em',
			xl: '80em',
			'2xl': '96em',
			'3xl': '1920px',
		},
	},

	badgeStyles,
	linkStyles,
	progressStyles,
	sliderStyles,
	inputStyles,
	textareaStyles,
	switchStyles,
	CardComponent,
);
